import createAxios from "./axiosHttp";

function getLiveLocations(date) {
  const axios = createAxios();
  const urlPath = "ttmm/location";
  return axios.get(urlPath, { params: { date } });
}

export const liveService = {
  getLiveLocations,
};
